// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 741) return "static/chunks/741-bbabcfe9f4237120.js";
	if (chunkId === 1911) return "static/chunks/1911-fbbbe74abd5dfef2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"521":"b766ef233d6cc968","2228":"420f9039a364b967","8964":"e7c8a5a3686976bd"}[chunkId] + ".js";
};